import { CupMark } from "./Logo";

const ITEMS = [
  "Chai Junction",
  "Brew & Bloom Café",
  "Madras Filter Co.",
  "Kadak Chai Co.",
  "Bombay Brew Club",
  "Tapri Tales",
  "Monsoon Coffee House",
  "Old Town Tea Room",
  "Street Sip Society",
  "Cutting Chai Collective",
];

export const Marquee = () => (
  <div
    className="relative bg-[#2E1065] py-5 overflow-hidden -rotate-1 scale-[1.02] my-4"
    data-testid="trusted-marquee"
  >
    <div className="flex w-max animate-marquee">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center shrink-0" aria-hidden={dup === 1}>
          {ITEMS.map((name) => (
            <span key={`${dup}-${name}`} className="flex items-center gap-6 px-6">
              <span className="font-display font-bold text-[#FAF7F2]/90 text-lg whitespace-nowrap tracking-wide">
                {name}
              </span>
              <CupMark className="w-5 h-5 rounded-md" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
